import React from 'react';
import { usePackages } from '../../../contexts/PackagesContext';
import { Checkbox } from '../../../components/ui/Input';

const MEDIA_TYPES  = ['image', 'video', 'audio', 'satellite', 'hdmi', 'usb'];
const LINK_TYPES   = ['youtube', 'wep', 'livestream'];
const LAYERS       = ['main', 'corner', 'playground', 'banner'];

export default function Step3({ errors, clearErrors, setError }) {
  const { selectedMediaTypes, setSelectedMediaTypes, selectedLayers, setSelectedLayers } = usePackages();

  const toggleMedia = (type, checked) => {
    const next = checked
      ? [...selectedMediaTypes, type]
      : selectedMediaTypes.filter(t => t !== type);
    setSelectedMediaTypes(next);
    if (next.length > 0) clearErrors('media_types');
    else setError('media_types', { message: 'Select at least one media type.' });
  };

  const toggleLinks = (checked) => {
    const next = checked
      ? [...new Set([...selectedMediaTypes, ...LINK_TYPES])]
      : selectedMediaTypes.filter(t => !LINK_TYPES.includes(t));
    setSelectedMediaTypes(next);
  };

  const toggleLayer = (layer, checked) => {
    const next = checked
      ? [...selectedLayers, layer]
      : selectedLayers.filter(l => l !== layer);
    setSelectedLayers(next);
    if (next.length > 0) clearErrors('layers');
    else setError('layers', { message: 'Select at least one layer.' });
  };

  const allLinksChecked = LINK_TYPES.every(t => selectedMediaTypes.includes(t));

  return (
    <div className="space-y-6">
      <div>
        <h4 className="text-sm font-semibold text-text-main mb-3">Media Types</h4>
        <div className="grid grid-cols-2 gap-3">
          {MEDIA_TYPES.map(t => (
            <Checkbox key={t} id={`mt-${t}`} label={t}
              checked={selectedMediaTypes.includes(t)}
              onChange={e => toggleMedia(t, e.target.checked)} />
          ))}
          <Checkbox id="mt-links" label="Links (YouTube / Web / Livestream)"
            checked={allLinksChecked}
            onChange={e => toggleLinks(e.target.checked)} />
        </div>
        {errors.media_types && <p className="mt-2 text-xs text-danger">{errors.media_types.message}</p>}
      </div>

      <div>
        <h4 className="text-sm font-semibold text-text-main mb-3">Multi-Layer</h4>
        <div className="grid grid-cols-2 gap-3">
          {LAYERS.map(l => (
            <Checkbox key={l} id={`layer-${l}`} label={l}
              checked={selectedLayers.includes(l)}
              onChange={e => toggleLayer(l, e.target.checked)} />
          ))}
        </div>
        {errors.layers && <p className="mt-2 text-xs text-danger">{errors.layers.message}</p>}
      </div>
    </div>
  );
}
